export enum DocumentCategoryEnum {
    EssayPilot = 1,
    LOR = 2,
    Identity = 3,
    Other = 4,
    Academics = 5,
    TestScores = 6
}

export enum CommonEssaySubTypeEnum {
    CommonAppEssay = 1,
    UCASEssay = 2,
    SOP = 3,
    BragSheet = 4,
    ScholarshipEssay = 5,
    Others = 6
}

export enum LorSubTypeEnum {
    Professional = 1,
    Academic = 2,
    Other = 3
}

export enum DocumentTypeEnum {
    Direct = 1,
    Drive = 2
}

export enum DocumentStatusEnum {
    Missing = 1,
    Uploaded = 2
}

export interface EssayInfoDto {
    essayType: EssayTypeEnum;
    essayQuestionId?: number;
    questionNumber?: number;
    selectedQuestionText?: string;
    essayCourseName?: string;
    commanEssayQuestionId?: number;
    commanEssayQuestionText?: string;
    commonEssaySubType?: number;
}

export interface LorInfoDto {
    lorSubType: number;
}

export interface StudentDocumentVaultResponse {
    id: string;
    title: string;
    category: DocumentCategoryEnum;
    docType: DocumentTypeEnum;
    path: string;
    fileType?: string | null;
    instituteId?: string;
    instituteName?: string;
    instituteImage?: string;
    essayInfo?: EssayInfoDto;
    lorInfo?: LorInfoDto;
    fileSize?: string;
    createdAt?: string;
    isReadOnly?: boolean;
    status: DocumentStatusEnum;
    isRequested: boolean;
    requestedByUserId?: string;
    requestedByUsername?: string;
    remarks: string | null;
}

export enum EssayTypeEnum {
    CommonEssay = 1,
    Institute = 2
}

export interface StudentDocumentVaultSearchResponse {
    id: string;
    title: string;
    docType: DocumentTypeEnum;
    category: DocumentCategoryEnum;
}

export interface StudentDocumentVaultCategoryCountResponse {
    category: DocumentCategoryEnum;
    count: number;
}

